import React from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity, useWindowDimensions } from 'react-native';
import { Trans } from '@lingui/react/macro';
import Header from './Header';
import colors from '../lib/colors';

export function McpPage({ children, welcome = false }: { children: React.ReactNode; welcome?: boolean }) {
    const compact = useWindowDimensions().width < 600;
    return <View style={styles.page}><Header /><ScrollView contentContainerStyle={[styles.scroll, welcome && compact && styles.welcomeScroll]}>
        <View style={[styles.card, welcome && styles.welcomeCard, welcome && compact && styles.welcomeCardCompact]}>{children}</View>
    </ScrollView></View>;
}
export function McpButton({ children, onPress, disabled, secondary = false }: {
    children: React.ReactNode; onPress: () => void; disabled?: boolean; secondary?: boolean;
}) {
    return <TouchableOpacity accessibilityRole="button" accessibilityState={{ disabled: !!disabled }}
        disabled={disabled} onPress={onPress} style={[styles.button, secondary && styles.secondary, disabled && { opacity: 0.5 }]}>
        <Text style={[styles.buttonText, secondary && { color: colors.text900 }]}>{children}</Text>
    </TouchableOpacity>;
}
export function McpPermissions({ scopes }: { scopes: string[] }) {
    return <View role="list" style={styles.permissions}>{scopes.map(scope => <View key={scope} role="listitem" style={styles.permissionRow}>
        <Text aria-hidden accessible={false} style={styles.body}>•</Text>
        <Text style={[styles.body, styles.permissionText]}>
            {scope === 'catalog:read' ? <Trans>Read public digests, paper details, and prepared Markdown</Trans>
                : scope === 'projects:read' ? <Trans>Read all your current and future projects and their feeds</Trans>
                    : scope === 'feedback:write' ? <Trans>Rate, star, or clear feedback on papers in your own project feeds</Trans>
                        : scope === 'markdown:generate' ? <Trans>Request Markdown processing for papers already in Paperzilla</Trans>
                            : scope === 'offline_access' ? <Trans>Stay connected until you revoke access or the connection expires</Trans> : scope}
        </Text>
    </View>)}</View>;
}
export const styles = StyleSheet.create({
    page: { flex: 1, backgroundColor: colors.bgWeak },
    scroll: { flexGrow: 1, alignItems: 'center', padding: 24, paddingTop: 48, paddingBottom: 80 },
    card: { width: '100%', maxWidth: 640, padding: 28, gap: 20, backgroundColor: colors.card, borderRadius: 18, borderWidth: 1, borderColor: colors.border },
    welcomeScroll: { padding: 16, paddingTop: 24, paddingBottom: 48 },
    welcomeCard: { maxWidth: 1000, padding: 36, borderRadius: 22 },
    welcomeCardCompact: { padding: 22 },
    backLink: { alignSelf: 'flex-start' },
    backLinkText: { fontSize: 16, color: colors.primaryGreen, fontWeight: '500' },
    title: { fontSize: 30, fontWeight: '700', color: colors.primaryGreenDark },
    heading: { fontSize: 20, fontWeight: '600', color: colors.text900 },
    body: { fontSize: 16, lineHeight: 24, color: colors.text700 },
    small: { fontSize: 13, lineHeight: 20, color: colors.text500 },
    permissions: { padding: 18, gap: 16, backgroundColor: colors.bgWeak, borderRadius: 10 },
    permissionRow: { flexDirection: 'row', alignItems: 'flex-start', gap: 10 },
    permissionText: { flex: 1, minWidth: 0 },
    button: { paddingVertical: 14, paddingHorizontal: 20, backgroundColor: colors.primaryGreenDark, borderRadius: 8, alignItems: 'center' },
    buttonText: { fontSize: 16, fontWeight: '600', color: '#fff' },
    secondary: { backgroundColor: colors.lightGray },
    error: { color: colors.errorRed, lineHeight: 22 },
    input: { borderWidth: 1, borderColor: colors.border, padding: 14, borderRadius: 8, fontSize: 16, color: colors.text900 },
    connection: { borderTopWidth: 1, borderColor: colors.border, paddingTop: 20, gap: 12 },
});
